import React, { useState, useEffect, useRef } from "react";
import GetAPI from "../../APICalls/GetAPI";
import PutAPI from "../../APICalls/PutAPI";
import PostAPI from "../../APICalls/PostAPI";
import AdminTabs from "../adminTabs";
import AdminModal from "../adminModal";
import XpressHeaders from "./xpressHeader";
import XpressDeclineAlert from "./xpressDeclineAlert";
import XpressOrders from "./xpressOrders";
import NewOrderPopUp from "./xpressNewOrderPopUp";
import moment from "moment";
import XpressContainer from "./XpressContainer";
import OrderDetailsPopup from "./OrderDetailsPopup";
import { ThreeCircles } from "react-loader-spinner";
import "./xpress.css";
import homealLogo from "../../../images/homealLogo.png";
import XpressBookDaasPopup from "./xpressBookDaasPopup";

const Xpress = () => {
  const [notVerified, setNotVerified] = useState(true);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [xpressData, setXpressData] = useState({ ALL: [], NEW: [] });
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [order, setOrder] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [status, setStatus] = useState("");
  const [searchOrderID, setSearchOrderID] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [showConfirmBookDaas, setShowConfirmBookDaas] = useState(false);
  const printRef = useRef();

  const handlePrint = () => {
    const printContent = printRef.current.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  let orderAPI, daasCreateOrderAPI;
  let environment = process.env.REACT_APP_NODE_ENV;
  if (environment === "PRODUCTION") {
    orderAPI = process.env.REACT_APP_PROD_ORDERAPI;
    daasCreateOrderAPI = process.env.REACT_APP_PROD_DAAS;
  } else {
    orderAPI = process.env.REACT_APP_DEV_ORDERAPI;
    daasCreateOrderAPI = process.env.REACT_APP_DEV_DAAS;
  }

  useEffect(() => {
    const fetchData = async () => {
      const completeURL = `${orderAPI}?type=XPRESS&deliveryDate=${date}`;
      try {
        const res = await GetAPI(completeURL);
        if (res.data.statusCode === 200) {
          const orders = res.data.body;
          setXpressData(orders);
        } else {
          setXpressData({ ALL: [], NEW: [] });
          console.error("Error occurred: ", res);
          alert("Failed to get xpress orders");
        }
      } catch (e) {
        setXpressData({ ALL: [], NEW: [] });
        console.error("Error occurred: ", e);
        alert("Failed to get xpress orders");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [date]);

  useEffect(() => {
    if (showConfirmPopup === false && order !== null && !isPopupVisible) {
      handlePopUpClose({ reason: undefined, status: "ACCEPTED" });
    }
  }, [order]);

  const handlePopUpClose = ({ reason, status }) => {
    const dataToPut =
      reason !== undefined
        ? {
            orderID: order.orderID,
            status: status,
            reasonToReject: reason,
            cost: order.cost,
            paymentStatus: "REFUND",
          }
        : {
            orderID: order.orderID,
            status: status,
          };

    setLoading(true);

    PutAPI(orderAPI, dataToPut)
      .then((res) => {
        if (status === "ACCEPTED") {
          handlePrint();
        } else {
          window.location.reload();
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
        alert("Unable to update order status. Please try again later");
      });
  };

  const handleVerified = (value) => {
    setNotVerified(value);
  };

  const handleDateChange = (event) => {
    setLoading(true);
    setDate(event.target.value);
  };

  useEffect(() => {
    if (xpressData?.ALL?.length > 0) {
      setFilterData(xpressData?.ALL);
    } else {
      setFilterData([]);
    }
  }, [xpressData]);

  useEffect(() => {
    if (searchOrderID !== "") {
      const filteredData = xpressData?.ALL.filter((order) =>
        order.orderID.includes(searchOrderID)
      );
      setFilterData(filteredData);
    } else {
      setFilterData(xpressData?.ALL);
    }
  }, [searchOrderID]);

  const handleBookDaas = () => {
    setIsPopupVisible(false);
    setShowConfirmBookDaas(true);
  };

  const handleDeliveryClick = (orderID, value) => {
    const dataToPut = {
      orderID: orderID,
      deliveryPartner: value
    };
    PutAPI(orderAPI, dataToPut)
      .then((res) => {
        setLoading(false);
        setOrder(null);
      })
      .catch((e) => {
        setLoading(false);
        alert("Failed  in changing delivery Status");
      });
  };

  const handleConfirmBookDaas = () => {
    setShowConfirmBookDaas(false);
    setLoading(true);
    const dataToPut = {
      orderID: order.orderID,
      status: "READY TO PICK"
    };
    PutAPI(orderAPI, dataToPut)
      .then((res) => {
        setLoading(false);
        alert("Booked daas successfully!!!")
        setOrder(null);
        window.location.reload();
      })
      .catch((e) => {
        setLoading(false);
        alert("Failed  in changing delivery Status");
      });
  };

  const handleCancelDaas = () => {
    setShowConfirmBookDaas(false);
    setIsPopupVisible(false);
    setLoading(true);

    const completeDaasCancelUrl =
      daasCreateOrderAPI + "/cancel?orderId=" + order.orderID;
    const dataToPost = {
      cancellationReason: "",
    };

    PostAPI(completeDaasCancelUrl, dataToPost)
      .then((res) => {
        handleDeliveryClick(order.orderID, "N/A");
        alert("Successfully Cancelled Daas!!");
        window.location.reload();
      })
      .catch((e) => {
        setLoading(false);
        console.log("Failed to cancel Daas response = " + e);
        alert("Failed to cancel Daas, try manual cancellation");
      });
  };

  return (
    <div>
      <AdminTabs />
      {notVerified ? (
        <AdminModal handleVerified={handleVerified} />
      ) : (
        <div className="xpressContainer">
          {loading && (
            <div className="spinnerContainer">
              <div className="spinner">
                <ThreeCircles
                  color="blue"
                  height={110}
                  width={110}
                  ariaLabel="three-circles-rotating"
                />
              </div>
            </div>
          )}
          {isPopupVisible && order && (
            <OrderDetailsPopup
              isVisible={isPopupVisible}
              onClose={() => setIsPopupVisible(false)}
              order={order}
              handleBookDaas={handleBookDaas}
              handleCancelDaas={handleCancelDaas}
              handlePrint={handlePrint}
            />
          )}
          <XpressDeclineAlert
            showConfirmPopup={showConfirmPopup}
            handlePopUpClose={handlePopUpClose}
            setShowConfirmPopup={setShowConfirmPopup}
          />
          <XpressBookDaasPopup
            showConfirmBookDaasPopup={showConfirmBookDaas}
            handleConfirmBookDaas={handleConfirmBookDaas}
            setShowConfirmBookDaasPopup={setShowConfirmBookDaas}
          />

          <XpressHeaders />
          <div className="container">
            <XpressContainer
              totalOrders={xpressData?.ALL?.length}
              date={date}
              setSearchOrderID={setSearchOrderID}
              handleDateChange={handleDateChange}
            />
            <XpressOrders
              xpressOrders={filterData}
              setIsPopupVisible={setIsPopupVisible}
              setOrder={setOrder}
              setStatus={setStatus}
            />
          </div>
          {window.innerWidth > 768
          ? <NewOrderPopUp
            xpressData={xpressData}
            setShowConfirmPopup={setShowConfirmPopup}
            setOrder={setOrder}
            handlePopUpClose={handlePopUpClose}
          /> : null}
          <div className="print" ref={printRef} style={{ display: "none" }}>
            <img src={homealLogo} className="logoSize" alt="..." />
            <p className="printDetails">
              Order ID: <strong>{order?.orderID}</strong>
            </p>
            <p className="printDetails">
              Craver Name: <strong>{order?.craverDetails.craverName}</strong>
            </p>
            <table>
              <thead>
                <tr>
                  <th>Qty</th>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {order?.orderedItems.map((item, id) => (
                  <tr key={id}>
                    <td>{item.quantity}</td>
                    <td>{item.menuName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Xpress;
